export default "/images/CPOtm-Logo-white.svg?38c622b89bb999d2fbedde4e04313c0e";